import { useContext, useState } from "react";
import { useSaveCandidateReviewMutation } from "../../../../../../App/Queries/ReviewQueries";
import { useNotification } from "../../../../../../App/State/Hooks/notificationHooks";
import { CandidateContext } from "../../../../../CandidateProfile";
import { useCurrentUser } from "../../../../../../App/Queries/UserQueries";

export function useAddReviewState() {
  const { candidate } = useContext(CandidateContext);
  const user = useCurrentUser();

  const [rating, setRating] = useState<number>(0);
  const [review, setReview] = useState<string>("");
  const [isReviewValid, setIsReviewValid] = useState<boolean>(true);

  const saveReviewMutation = useSaveCandidateReviewMutation();
  const { isLoading: saveReviewLoading } = saveReviewMutation;

  const { displaySuccess, displayError } = useNotification();
  const handleReviewChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setReview(event.target.value);
    setIsReviewValid(event.target.value.length <= 1500 ? true : false);
  };
  const handleSaveReview = async () => {
    saveReviewMutation.mutate(
      {
        candidateId: candidate.id,
        rating,
        review,
        reviewerId: user.id,
      },
      {
        onError: () => displayError("There was an error saving your review. Please try again!"),
        onSuccess: () => {
          setRating(0);
          setReview("");
          displaySuccess("Review saved!");
        },
      },
    );
  };

  return {
    effects: {},
    getters: {
      isReviewValid,
      rating,
      review,
      saveReviewLoading,
    },
    handlers: {
      handleReviewChange,
      handleSaveReview,
    },
    setters: {
      setRating,
      setReview,
    },
  };
}
